/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Any {
  "@type"?: string;
  [key: string]: any;
}

export interface CreateOrdersRequest {
  filtering?: OrdersFiltering;
}

export interface CreateOrdersResponse {
  id?: string;
}

export interface CreateShipmentsRequest {
  filtering?: Filtering;
  ids?: string[];
}

export interface CreateShipmentsResponse {
  id?: string;
}

export interface CreateSpecialReportRequest {
  filtering?: Filtering;
  /** Type of the report */
  report_type?: SpecialReportType;
  shipment_ids?: string[];
  tos_ids?: string[];
}

export interface CreateSpecialReportResponse {
  /** Id of the report */
  id?: string;
}

/** Provides a date interval. Depending on a case, `start` and `end` parts are not guaranteed to be present. */
export interface DateTimeRange {
  /** End of the interval. Date is returned in RFC3339 format. Example `2018-09-08T22:47:31Z`. */
  end?: string;
  /** Start of the interval. Date is returned in RFC3339 format. Example `2018-09-08T22:47:31Z` */
  start?: string;
}

export interface FilterCountRange {
  /** @format int64 */
  max?: string;
  /** @format int64 */
  min?: string;
}

export interface Filtering {
  address_from_countries?: string[];
  address_to_countries?: string[];
  /** Provides a date interval. Depending on a case, `start` and `end` parts are not guaranteed to be present. */
  created_at_range?: DateTimeRange;
  /** Id will be matched against shipment_id, tos_id and external_id. */
  id?: string;
  line_items?: FilterCountRange;
  /** Provides a date interval. Depending on a case, `start` and `end` parts are not guaranteed to be present. */
  shipping_date_range?: DateTimeRange;
  shipping_methods?: string[];
  statuses?: string[];
}

export interface GetOrdersResponse {
  orders?: Orders;
}

export interface GetShipmentsResponse {
  shipments?: Shipments;
}

export interface GetSpecialReportResponse {
  report?: SpecialReport;
}

export interface Orders {
  created_at?: string;
  id?: string;
  status?: Status;
  uri?: string;
}

export interface OrdersFiltering {
  /** Provides a date interval. Depending on a case, `start` and `end` parts are not guaranteed to be present. */
  created_at_range?: DateTimeRange;
  id?: string;
  sources?: string[];
}

export interface Shipments {
  created_at?: string;
  id?: string;
  status?: Status;
  uri?: string;
}

export interface SpecialReport {
  created_at?: string;
  id?: string;
  status?: Status;
  uri?: string;
}

/** @default "REPORT_TYPE_UNKNOWN" */
export type SpecialReportType = "REPORT_TYPE_UNKNOWN" | "BBX_INVOICE_SHIPMENTS";

/** @default "UNKNOWN_STATUS" */
export type Status = "UNKNOWN_STATUS" | "PENDING" | "DONE" | "ERROR";

export interface Error {
  /** @format int32 */
  code?: number;
  details?: Any[];
  message?: string;
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "/v1/reports" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Reports API
 * @version 1.0
 * @baseUrl /v1/reports
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  ordersCreate = {
    /**
     * No description
     *
     * @name ReportsCreateOrders
     * @request POST:/orders.create
     * @secure
     */
    reportsCreateOrders: (body: CreateOrdersRequest, params: RequestParams = {}) =>
      this.request<CreateOrdersResponse, Error>({
        path: `/orders.create`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  ordersGet = {
    /**
     * No description
     *
     * @name ReportsGetOrders
     * @request GET:/orders.get
     * @secure
     */
    reportsGetOrders: (
      query?: {
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetOrdersResponse, Error>({
        path: `/orders.get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  shipmentsCreate = {
    /**
     * No description
     *
     * @name ReportsCreateShipments
     * @request POST:/shipments.create
     * @secure
     */
    reportsCreateShipments: (body: CreateShipmentsRequest, params: RequestParams = {}) =>
      this.request<CreateShipmentsResponse, Error>({
        path: `/shipments.create`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  shipmentsGet = {
    /**
     * No description
     *
     * @name ReportsGetShipments
     * @request GET:/shipments.get
     * @secure
     */
    reportsGetShipments: (
      query?: {
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetShipmentsResponse, Error>({
        path: `/shipments.get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  specialReportCreate = {
    /**
     * No description
     *
     * @name ReportsCreateSpecialReport
     * @summary Special reports that are handled by event listeners in carrier services
     * @request POST:/special-report.create
     * @secure
     */
    reportsCreateSpecialReport: (body: CreateSpecialReportRequest, params: RequestParams = {}) =>
      this.request<CreateSpecialReportResponse, Error>({
        path: `/special-report.create`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  specialReportGet = {
    /**
     * No description
     *
     * @name ReportsGetSpecialReport
     * @request GET:/special-report.get
     * @secure
     */
    reportsGetSpecialReport: (
      query?: {
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetSpecialReportResponse, Error>({
        path: `/special-report.get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
